export default "__VITE_ASSET__BZYdNLUB__"